import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ApplicantService } from './application-management.service';
import { MemberDetailsResponseModel, MemberStatusModel } from './application-management-popup.model';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.less'],
})

export class UserComponent implements OnInit {
  @Input() showUser: boolean;
  @Input() applicantId;
  @Output() showUserChange = new EventEmitter<boolean>();
  @Output() showApplicantInfoChange = new EventEmitter();

  statusPopup = false;
  acceptUser = false;
  rejectUser = false;
  waitlistUser = false;
  // False while SetStatus is in flight. Accepting a Premium applicant waits on the Stripe charge, so
  // the request takes seconds - and every repeat click used to POST again and could charge again.
  buttonsEnabled = true;

  updatedStatus: string;

  userPopupModel = new MemberDetailsResponseModel();
  memberStatusModel = new MemberStatusModel();

  selectedImageForPreview: string;

  constructor(private _applicantService: ApplicantService) {
  }

  ngOnInit() {
    this._applicantService.getUserInfo(this.applicantId)
      .subscribe(
        (response: MemberDetailsResponseModel) => {
          this.userPopupModel = response;
          this.userPopupModel = response;

          this.userPopupModel = response;
          if (this.userPopupModel.website && this.userPopupModel.website.length) {
            if (this.userPopupModel.website.indexOf("http") != 0) {
              this.userPopupModel.website = `http://${this.userPopupModel.website}`
            }
          }

        },
        (error) => console.log(error));

  }

  close() {
    this.showUserChange.emit(false);
  }

  accept() {
    this.statusPopup = true;
    this.acceptUser = true;
    this.updatedStatus = 'Accepted';
  }

  reject() {
    this.statusPopup = true;
    this.rejectUser = true;
    this.updatedStatus = 'Rejected';
  }

  waitlist() {
    this.statusPopup = true;
    this.waitlistUser = true;
    this.updatedStatus = 'Waitlisted';
  }

  cancel() {
    // A sent status change cannot be taken back, so the popup stays up until the API answers.
    if (!this.buttonsEnabled) {
      return;
    }
    this.acceptUser = false;
    this.rejectUser = false;
    this.waitlistUser = false;
    this.statusPopup = false;
  }

  updateStatus() {
    if (!this.buttonsEnabled) {
      return;
    }
    this.buttonsEnabled = false;
    this.memberStatusModel.memberId = this.applicantId;
    this.memberStatusModel.status = this.updatedStatus;
    this._applicantService.updateApplicantStatus(this.memberStatusModel)
      .subscribe(
        (response) => {
          console.log(response);
          this.buttonsEnabled = true;
          this.cancel();
          this.close();
          this.showApplicantInfoChange.emit();
        },
        (error) => {
          this.buttonsEnabled = true;
          console.log(error);
        }
      );
  }

  closePopUp() {
    this.selectedImageForPreview = null;
  }
}



// WEBPACK FOOTER //
// C:/NightKey/CMS/nightkey-cms/src/app/members/application-management/user.component.ts